import React, { useContext } from 'react';
import { useParams, useHistory } from 'react-router-dom';
import Routes from 'Routes';
import { UserSessionContext } from 'components/UserSession';
import BoothPageContentContainer from 'pages/booths/BoothPageContentContainer';

const BoothPreviewPage = () => {
  const history = useHistory();
  const { isAuthenticated } = useContext(UserSessionContext);
  const { boothId } = useParams<any>();

  if (isAuthenticated) {
    history.replace(Routes.booth(boothId));
  }

  return <BoothPageContentContainer isPreview />;
};

export default BoothPreviewPage;
